var AWS = require('aws-sdk');

const { DynamoDB, DynamoDBClient } = require("@aws-sdk/client-dynamodb");
const { marshall, unmarshall } = require("@aws-sdk/util-dynamodb");

const client = new DynamoDBClient({accessKeyId: process.env.REACT_APP_AWS_accessKeyId, secretAccessKey: process.env.REACT_APP_AWS_secretAccessKey, region: "us-east-2"});

AWS.config.update({accessKeyId: process.env.REACT_APP_AWS_accessKeyId, secretAccessKey: process.env.REACT_APP_AWS_secretAccessKey, region: "us-east-2"});
let tableName = 'logs'
let ddbDocumentClient = new AWS.DynamoDB.DocumentClient();

let cache = { 
}

function validCache(id) { 
    if (cache.id != undefined) { 
        return true 
    } else { 
        return false
    }
}

export const scanForResults = async (id = 'all', refresh = false) =>{
    try {
        var params = {
            TableName: tableName
            // KeyConditionExpression: 'runType = :runType',
            // ExpressionAttributeValues: {
            //     ':runType': {'S': 'dev'}
            // },
        };
        var result = undefined
        console.log("Refresh", refresh)
        if (refresh === true) { 
            console.log("Scanning Dynamo - Manual refresh")
            result = await ddbDocumentClient.scan(params).promise()
            cache.id = result
        } else if (validCache(id)) { 
            console.log('Returning from cache', cache)
            return cache.id
        } else { 
            console.log("Scanning Dynamo - Empty cache")
            result = await ddbDocumentClient.scan(params).promise()
            cache.id = result
        }
        
        return result
    } catch (error) {
        console.error(error);
    }
}
export const getSettings = async () =>{
    try {
        var params = {
            TableName: 'settings'
            // KeyConditionExpression: 'runType = :runType',
            // ExpressionAttributeValues: {
            //     ':runType': {'S': 'dev'}
            // },
        };
        const result = await client.scan(params).promise()

        return result
    } catch (error) {
        console.error(error);
        return null
    }
}

export const updateSettings = async (data) =>{
    try {
        var params = {
            TableName: 'settings', 
            Key: marshall(data)
            // KeyConditionExpression: 'runType = :runType',
            // ExpressionAttributeValues: {
            //     ':runType': {'S': 'dev'}
            // },
        };
        const client = new DynamoDB({ region: "REGION" });
        let result;
        try {
            const { Item } = await client.getItem(params);
            // Convert the DynamoDB record you retrieved into a JavaScript object
            unmarshall(Item);
            // Print the JavaScript object to console
            console.log(Item);
            result = Item
          } catch (err) {
            console.log("Error", err);
          }

        return result
    } catch (error) {
        console.error(error);
        return null
    }
}

